import { serviceMaker } from "..";
import {
  IContact,
  INewsletter,
} from "../../public/contact-us/ContactUsViewController";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";
import { encryptData } from "../../utils/AppFunctions";

export const ADD_CONTACT_DETAILS = (payload: IContact, token: any) =>
  serviceMaker(
    API_ENDPOINTS.add_contact_detail.url,
    API_ENDPOINTS.add_contact_detail.method,
    { payload: encryptData(JSON.stringify(payload)) },
    token
  );
export const ADD_NEWSLETTER_DETAIL = (payload: string) =>
  serviceMaker(
    API_ENDPOINTS.add_newsletter_detail.url,
    API_ENDPOINTS.add_newsletter_detail.method,
    { payload: encryptData(JSON.stringify({ email: payload })) }
  );
